import { SxProps, Theme } from "@mui/material";

export const appBarStyles = (isEliteDeals: boolean): SxProps<Theme> => ({
	zIndex: 1201, // at 1200 hidden below sidebar
	marginRight: { lg: "auto" },
	position: { lg: "fixed" },
	justifyContent: { xs: "flex-end", sm: "center" },
	height: { xs: 55, sm: "initial" },
	top: 0,
	left: 0,
	right: 0,
	background: {
		xs: "#00789E",
		sm: "linear-gradient(90deg, #00789E 22.73%, #00D7CA 78.32%)"
	},
	"&::before": {
		content: "''",
		position: "absolute",
		inset: 0,
		background: {
			xs: "linear-gradient(90deg, #EDB500 0%, #ED9A00 100%)"
		},
		opacity: isEliteDeals ? 1 : 0,
		transition: "opacity 0.5s ease-in-out",
		pointerEvents: "none",
		zIndex: -1
	},
	"@media(max-width: 600px)": {
		justifyContent: { xs: "center" }
	}
});
